<style lang="less" scoped>
  .content {
    position: relative;
  }
  .progress {
    position: absolute;
    right: 0;
    top: 16px;
  }
  .empty {
    display: none;
  }
  .card-container.single {
    display: flex;
    align-items: center;
    justify-content: center;
    .card-component {
      width: 194px;
      height: 272px;
      &:nth-of-type(1),
      &:nth-of-type(3) {
        opacity: .6;
        position: absolute;
      }
      &:nth-of-type(1) {
        left: 0;
        transform: scale(.7) translateX(-80%)
      }
      &:nth-of-type(3) {
        right: 0;
        transform: scale(.7) translateX(80%);
      }
    }
  }
  .card-container.multiple {
    .card-home {
      position: absolute;
      bottom: 40px;
      left: 50%;
      .card-component {
        width: 210px;
      }
      &:nth-of-type(1) {
        z-index: 3;
        transform: translate(-50%)
      }
      &:nth-of-type(2) {
        z-index: 2;
        transform: translate(-50%, -50px) scale(.9);
      }
      &:nth-of-type(3) {
        z-index: 1;
        transform: translate(-50%, -100px) scale(.8);
      }
    }
  }
</style>

<template lang="pug">
  .std-layout
    .header
      header-component(
        @click-stop='redirectBack'
        @click-recall='done')
    .content
      progress-component.progress(
        :current='current + 1'
        :max='answerCount'
        :unit='"묶음"')
      .card-container.single(v-if='units == 1')
        card-component.card-component(
          v-for='(data, key) in display'
          :data='data')
      .card-container.multiple(v-else)
        .card-home(
          v-for='(data, key) in display'
          :style='{ width: getWidth(data) + "px" }')
          card-component.card-component(
            :data='data'
            :overlay='0.3 * key')
    .footer
      footer-component(
        :time='time'
        :last='isLast'
        :text='"리콜"'
        @click-prev='prev'
        @click-next='next'
        @click-complete='done')
</template>

<script>
import HeaderComponent from '@/components/header/header_recall';
import CardComponent from '@/components/card';
import ProgressComponent from '@/components/current_max_progress';
import FooterComponent from '@/components/footer/timer_arrow';

export default {
  data() {
    return {
      time: 0,
      current: 0,
      score: 0,
      display: [],
    };
  },
  watch: {
    current() {
      this.display = this.getDisplay();
    },
  },
  computed: {
    isLast() {
      return this.answerCount - 1 === this.current;
    },
    answer() {
      return this.$store.state.app.answer;
    },
    answerCount() {
      return this.answer.length;
    },
    units() {
      return this.$store.state.app.units;
    },
    endTime() {
      return 60 * this.$store.state.app.time;
    },
  },
  methods: {
    progressTimer() {
      this.time += 1;
      if (this.time >= this.endTime) {
        this.done();
      }
    },
    getWidth(data) {
      const defaultWidth = 200;
      const margin = 40;
      return defaultWidth + (margin * (data.length - 1));
    },
    getDisplay() {
      const result = [];
      if (this.units === 1) {
        let index = 0;
        for (let i = this.current - 1; i <= this.current + 1; i += 1) {
          const data = this.answer[i];
          if (data) {
            result[index] = data;
          }
          index += 1;
        }
      } else if (this.units >= 2) {
        let index = 0;
        for (let i = this.current; i <= this.current + 2; i += 1) {
          const data = this.answer[i];
          if (data) {
            result[index] = data;
          }
          index += 1;
        }
      }
      return result;
    },
    redirectBack() {
      this.$router.go(-1);
    },
    next() {
      if (this.current + 1 < this.answer.length) {
        this.current += 1;
        const score = this.answer[this.current].length;
        this.addScore(score);
      }
    },
    prev() {
      if (this.current - 1 >= 0) {
        const score = this.answer[this.current].length;
        this.removeScore(score);
        this.current -= 1;
      }
    },
    done() {
      this.$store.commit('setUsedTime', this.time);
      this.$router.replace({ name: 'TrainingCardRecall' });
    },
    addScore(score) {
      this.score += score;
    },
    removeScore(score) {
      this.score -= score;
    },
  },
  mounted() {
    /* 최초로 보여지는 카드에 대한 점수 지급 */
    this.display = this.getDisplay();
    const firstIndex = this.display.length == 1 ? 0 : 1;
    const score = this.display[firstIndex].length;
    this.addScore(score);

    if (!this.answer) {
      this.$router.replace({ name: 'TimeCard' });
    }
    window.intervalID = setInterval(this.progressTimer, 1000);
  },
  beforeDestroy() {
    clearInterval(window.intervalID);
  },
  components: {
    HeaderComponent,
    ProgressComponent,
    CardComponent,
    FooterComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/card/start.vue